




































































































import firebase from 'firebase'
import fbconfig from './store/fbconfig.js'
# Required for side-effects
require("firebase/firestore")

import { mapGetters } from 'vuex'
import Login from './components/Login.vue'

export default {
  name: 'App'
  data: -> {
    snackbar: false
    rightDrawer: false
    title: 'Personal Knowledge Base Web App'
  }
  components: {Login}

  computed: {
    ...mapGetters ['isLoading', 'isBusy', 'error', 'darkTheme']
    isDisconnected: -> not this.$store.getters.isConnected
    breadcrumbs: ->
      breadcrumbs = []
      selected = this.$store.getters.selectedNote
      while selected?.parent?
        # hey, at least I didn't use regex
        hack = selected.text.split('<', 3)
        awfulHack = '<' + hack[1] + '<' + hack[2]
        breadcrumbs.unshift({text:awfulHack})
        selected = this.$store.getters.note(selected.parent)
        # break if selected.parent == "rootNode"
      return breadcrumbs
  }

  methods:
    logOut: ->
      console.log "logOut"
      firebase.auth().signOut()
    toggleTheme: -> this.$store.commit('toggleTheme')

  watch:
    error: (newError) ->
      if newError != ""
        console.log "error", newError, this
        this.snackbar = true
        setTimeout(() =>
          console.log "test"
          this.$store.commit('setError', "")
        , 6500)
    darkTheme: (newVal) ->
      this.$vuetify.theme.primary =  if newVal then '#00695C' else '#4db6ac'
      this.$vuetify.theme.secondary =  if newVal then '#263238' else '#eceff1'
      this.$vuetify.theme.error =  if newVal then '#b71c1c' else '#ef5350'

  created: ->
    if (process.env.NODE_ENV != 'production')
      firebase.initializeApp(fbconfig.dev)
    else
      firebase.initializeApp(fbconfig.prod)

    firebase.auth().onAuthStateChanged((user) =>
      if user
        this.$store.dispatch('signIn', user)
      else
        this.$store.dispatch('signOut')
    )
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue